/**
 * Runtime configuration. Terraform writes /config.js after it knows the Cognito client id, so
 * the bundle never has to be rebuilt when an infrastructure value changes — and a build does
 * not need to run after an apply just to learn an id.
 */
export interface RuntimeConfig {
  readonly apiUrl: string;
  readonly authDomain: string;
  readonly cognitoClientId: string;
  /** Exactly what the Cognito app client accepts: COGNITO, and any federated provider names. */
  readonly identityProviders: readonly string[];
}

declare global {
  interface Window { __GC_CONFIG__?: Partial<RuntimeConfig> }
}

const fromWindow = typeof window === 'undefined' ? {} : (window.__GC_CONFIG__ ?? {});

export const config: RuntimeConfig = {
  apiUrl: fromWindow.apiUrl ?? 'https://api.gadgetcloud.io',
  authDomain: fromWindow.authDomain ?? 'https://auth.gadgetcloud.io',
  cognitoClientId: fromWindow.cognitoClientId ?? '',
  // Defaults to the email code alone. Offering a provider that is not configured sends the
  // visitor to a Cognito error page, so the safe default is the one that always exists.
  identityProviders: fromWindow.identityProviders ?? ['COGNITO'],
};
